export default __webpack_public_path__ + "static/media/64.41620069.jpeg";